<template>
  <div>
    <div>
      <PageLoader v-if="loading"/>
      <div class="warning" v-if="!loading && dataCam.length === 0 && curveWeightReference.length === 0">
        <br /><br />
        <div class="text">
          <h1>Sem curva de referencia, contatar ao suporte de Pecsmart</h1>
        </div>
      </div>
      <div class="warning" v-else-if="!loading && dataCam.length === 0">
        <br /><br />
        <div class="text">
          <h1>Sem dados de camera, contatar ao suporte de Pecsmart</h1>
        </div>
      </div>
      <div v-else-if="!loading">
        <div v-if="missingWeightCurve" class="curve-warning" role="alert">
          <strong>Atenção:</strong> falta a curva de ganho de peso de referência para este tipo de animal.
          Os dados da câmera continuam sendo exibidos, mas a linha <em>Esperado</em> e as comparações
          com a referência ficam indisponíveis. Contate o suporte Pecsmart para configurar a curva.
        </div>
        <OpenBalenaCard :sensor="camSensor" />
        <SmartCamV3
          :curveWeightReference="curveWeightReference"
          :userLevel="userLevel"
          :batchData="batch"
          :camV3Data="dataCam"
          :lossesData="losses"
        />
      </div>

    </div>
    <ModalStyle>
      <RegisterBatchModal />
    </ModalStyle>
  </div>
</template>

<script>
import PageLoader from '../components/Loader.vue'
import ModalStyle from "../components/ModalStyle.vue";
import RegisterBatchModal from "../components/RegisterBatchModalOld.vue";
import SmartCamV3 from './SmartCamV3.vue'
import OpenBalenaCard from './OpenBalenaCard.vue'
import { sensorScreenBlocked } from '../utils/feedInventoryAccess'

export default{
  name: 'SmartCamPage',
  components:{
      PageLoader,
      ModalStyle,
      RegisterBatchModal,
      SmartCamV3,
      OpenBalenaCard
  },
  data() {
    return{
      loading: true,
      camDataLocal: []
    }
  },
  computed:{
    curveWeightReference() {
      const fromStore = this.$store?.getters?.getCurveWeightReference
      if (Array.isArray(fromStore) && fromStore.length > 0) return fromStore

      const fromBatch = this.batch?.reference_weight_curve
      if (Array.isArray(fromBatch) && fromBatch.length > 0) return fromBatch

      return Array.isArray(fromStore) ? fromStore : []
    },
    companySettings() {
      return this.$store?.getters?.getCompanySettings ?? []
    },
    useCamV2IfV3NotAvailable() {
      return this.companySettings?.settings?.client_frontend?.use_cam_v2_if_v3_not_available ?? false
    },
    losses() {
      return this.$store?.getters?.getLossesBatch ?? []
    },
    batch() {
      return this.$store.getters.getBatchTarget
    },
    userLevel() {
      return this.$store.getters.getUserLevel
    },
    dataCam() {
      if (this.camDataLocal.length > 0) return this.camDataLocal
      const fromStore = this.$store.getters.getSmartCamData
      return Array.isArray(fromStore) ? fromStore : []
    },
    missingWeightCurve() {
      return this.dataCam.length > 0 && this.curveWeightReference.length === 0
    },
    /** Sensor SmartCam do curral (barn.sensors) usado para o card Open Balena. */
    camSensor() {
      try {
        const barn = this.$store.getters.getBarnTarget
        return (barn?.sensors || []).find(sensor => sensor.type === 'smartcam') || null
      } catch (err) {
        return null
      }
    }
  },
  async created() {
    if (sensorScreenBlocked(this.$store.getters.getCurrentUser, this.$store.getters.getCompanySettings)) {
      this.loading = false
      return
    }
    if (!this.$store.getters.getHeader && window.localStorage.getItem('Token')) {
      this.$store.commit('setHeader', window.localStorage.getItem('Token'))
    }
    if (this.batch?.animal_type != null) {
      await this.$store.dispatch('fetchReferenceWeightCurve', this.batch.animal_type)
    }
    const camData = await this.$store.dispatch('fetchCamData', this.batch.pk)
    if (Array.isArray(camData) && camData.length > 0) {
      this.camDataLocal = camData
    }
    await this.$store.dispatch('fecthLossesByBatch', {batch: this.batch.pk, url: null})
    this.loading = false
  }

}

</script>

<style scoped>
.curve-warning {
  margin: 16px auto 0;
  max-width: 1140px;
  padding: 12px 16px;
  border-radius: 8px;
  border: 1px solid #e2bf65;
  background: #fff8e6;
  color: #5c4a1a;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.4;
}

.register-batch {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 50vh;
}

.register-batch button {
  width: 400px;
  height: 200px;
  background: #fff;
  border: 4px solid #78b843;
  border-radius: 10px;
  outline: none;
  transition: 0.2s ease-out
}

.register-batch button h1 {
  font-size: 60px;
  color: #78b843
}

.register-batch button:hover {
  background: #78b843;
}

.register-batch button:hover h1,
.register-batch button:hover p{
  color: #fff;
}

.register-batch button p {
  font-size: 30px;
  color: #78b843;
  padding: 10px;
  margin: 0;
}

@media screen and (max-width: 768px) {
  .warning {
    height: 250px;
  }

  .warning h1 {
    font-size: 30px;
  }

  .warning p {
    font-size: 20px;
  }

  .register-batch {
    height: 220px;
  }

  .register-batch button {
    width: 250px;
    height: 150px;
    font-size: 25px;
    outline: none;
    transition: 0.2s ease-out
  }

  .register-batch button h1 {
    font-size: 32px;
  }

  .register-batch button p {
    font-size: 20px;
  }
}
</style>
